import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";

/* ================= DEFAULT MIND-MINING GAMES ================= */
const DEFAULT_MIND_MINING_GAMES = [
  {
    id: 1,
    title: "puzzle master",
    image: "/assets/gamescard/puzzle-master.png",
    link: "https://thegameio.ng/jigsaw-puzzle/",
  },
  { id: 2, title: "Genius", image: "/assets/gamescard/genius.png", link: "https://thegameio.ng/genius/", },
  { id: 3, title: "Sudoku", image: "/assets/gamescard/sudoku.png", link: "https://thegameio.ng/sudoku/", },
  { id: 4, title: "Slider Puzzle", image: "/assets/gamescard/sliderpuzzle.png", link: "https://thegameio.ng/slider-puzzle/", },
  { id: 5, title: "Spelling Challenge", image: "/assets/gamescard/spellingchllange.png", link: "https://thegameio.ng/spelling-challenge/", },
  { id: 6, title: "3D Maze", image: "/assets/gamescard/3dmaze.png", link: "https://thegameio.ng/3dmaze/",},
  {
    id: 7,
    title: "Neon Pong",
    image: "/assets/gamescard/neonpong.png",
    link: "https://thegameio.ng/ai-puzzle/",
  },
  { id: 8, title: "Connect Four Classic", image: "/assets/gamescard/connectfour.png", link: "https://thegameio.ng/connect-four-classic/", },
  { id: 9, title: "Archery Master", image: "/assets/gamescard/shooting.png", link: "https://thegameio.ng/shooting-game/", },
  { id: 10, title: "Water Sort", image: "/assets/gamescard/watersort.png", link: "https://thegameio.ng/water-sort-puzzle/", },
  { id: 11, title: "Color Spinner", image: "/assets/gamescard/color-spinner.png", link: "https://thegameio.ng/color-spinner/", },
  { id: 12, title: "Juicy Puzzle", image: "/assets/gamescard/juicy-puzzle.png", link: "https://thegameio.ng/juicy-puzzle/",},
  { id: 13, title: "tetris-evolution", image: "/assets/gamescard/tetris-evolution.png", link: "https://thegameio.ng/tetris-evolution/", },
  { id: 14, title: "Word Puzzle", image: "/assets/gamescard/word-puzzle.png", link: "https://thegameio.ng/word-puzzle.jpg/", },
  { id: 15, title: "Guess The Quezz", image: "/assets/gamescard/guessquiz.png", link: "https://thegameio.ng/engaging-emoji/", },
];

/* ================= COMPONENT ================= */
const MindMining = () => {
  const navigate = useNavigate();

  // ✅ SAME LOGIN CHECK AS TRENDING / NEW RELEASE
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  // ✅ SAME CLICK HANDLER AS TRENDING
  const handleGameClick = (game) => {
    if (!isLoggedIn) {
      navigate("/games");
      return;
    }

    if (game.link) {
      window.open(game.link, "_self", "noopener,noreferrer");
    } else {
      navigate("/games");
    }
  };

  return (
    <div className="first-games-slider mt-[50px] sm:mt-0 md:mt-5 lg:mt-5 xl:mt-5">
      <div className="w-full py-0 sm:py-10 md:py-10 lg:py-10 xl:py-10 px-4">
        <div className="max-w-6xl mx-auto">

          {/* ================= HEADER ================= */}
          <div className="flex flex-wrap justify-between items-center mb-8 gap-4">
            <p className="text-white font-[Open Sans] text-[22px] sm:text-[25px] md:text-3xl font-semibold uppercase">
              Mind-mining games
            </p>

            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate("/games")}
                className="btn-hover bg-[#3a3f5c] text-white px-4 sm:px-6 py-2 rounded-lg text-sm sm:text-base"
              >
                <span>View All</span>
              </button>

              <button className="swiper-button-prev-mind btn-hover bg-[#3a3f5c] w-10 h-10 sm:w-12 sm:h-10 rounded-lg flex items-center justify-center">
                <span><IoIosArrowBack size={18} color="#fff" /></span>
              </button>

              <button className="swiper-button-next-mind btn-hover bg-[#3a3f5c] w-10 h-10 sm:w-12 sm:h-10 rounded-lg flex items-center justify-center">
                <span><IoIosArrowForward size={18} color="#fff" /></span>
              </button>
            </div>
          </div>

          {/* ================= SLIDER ================= */}
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={{
              prevEl: ".swiper-button-prev-mind",
              nextEl: ".swiper-button-next-mind",
            }}
            autoplay={{ delay: 3500, disableOnInteraction: false }}
            loop
            spaceBetween={20}
            breakpoints={{
              0: { slidesPerView: 2, spaceBetween: 10 },
              480: { slidesPerView: 2, spaceBetween: 12 },
              640: { slidesPerView: 3, spaceBetween: 16 },
              768: { slidesPerView: 3, spaceBetween: 20 },
              1024: { slidesPerView: 4, spaceBetween: 20 },
              1280: { slidesPerView: 5, spaceBetween: 20 },
            }}
            className="trending-swiper"
          >
            {DEFAULT_MIND_MINING_GAMES.map((game) => (
              <SwiperSlide key={game.id}>
                <div
                  className="group cursor-pointer flex flex-col h-full"
                  onClick={() => handleGameClick(game)}
                >
                  {/* CARD */}
                  <div className="rounded-xl border border-gray-800 hover:border-yellow-500 transition-all duration-300 bg-[#0f0f18] overflow-hidden">

                    {/* IMAGE FIX (NO CROP, CENTERED) */}
                    <div
                      className="
                        w-full
                        h-[120px]
                        sm:h-[160px]
                        md:h-[180px]
                        lg:h-[200px]
                        flex
                        items-center
                        justify-center
                        bg-black
                      "
                    >
                      <img
                        src={game.image}
                        alt={game.title}
                        className="
                          max-w-full
                          max-h-full
                          object-fill
                          transition-transform
                          duration-500
                          group-hover:scale-105
                        "
                      />
                    </div>
                  </div>

                  {/* TITLE */}
                  <h3 className="text-white font-[Roboto Mono] text-sm sm:text-base md:text-lg font-semibold mt-4 text-center">
                    {game.title}
                  </h3>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        </div>
      </div>
    </div>
  );
};

export default MindMining;
